import React from 'react'
import './HomeCard.css';
import Card from './Card';
function HomeCard() {
    return (
        <div className="home_card">
      <div className="homecard_container">
<div className='leftt'>
<h1>Fast Fix</h1>

  </div>  
  <div className='rightt'>
    <h2>About Us </h2>
  <p>Fast Fix is an online platform that connects offline workers with local demand, allowing consumers to find immediate help with everyday tasks, including cleaning, moving, delivery and handyman work.</p>

    </div>    
      </div>
    </div>
    )
}

export default HomeCard